<template>
  <div class="full-page-width relative locations">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('automations-info-text')"
          :title="$t('automation')"
          :btnText="$t('Add automation')"
          @action="openNewPopup" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            class="list-table-item"
            @click="goToAutomation(item.id)"
            v-for="(item, index) in get_automations.items" :key="`item-${index}`">
            <div class="table-cell small" :key="`item-icon-${index}`">
              <div class="list-icon-block">
                <div class="status-indicator" :class="getStatusClass(item.status)"></div>
                <Icon
                  :circle=true
                  :name="getIconNameByType(item.type)"
                  size="20"/>
              </div>
            </div>
            <div class="table-cell">
              <p>
              <span class="main-info">
                {{ `${item.name || '-'}` }}
              </span>
                <span class="additional-info">
                  {{ `${$t(get_automations.entity.types[item.type])}` }}
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      :popupSmall=true
      min-height="300px"
      @cancel="togglePopup"
      @confirm="submitForm">
      <template v-slot:header>
        <h2>{{ $t('Add automation') }}</h2>
      </template>
      <div>
        <div class="row" v-if="get_user.is_admin">
          <div class="col-xs-12 m-b-20">
            <InputSelect
              class="m-b-20"
              :multiSelect=true
              :preselected="form.accessible_for_subaccounts"
              :label="$t('accessible_for_accounts')"
              @change="selectAccessibleSubaccount"
              :rules="{required: true}"
              :options="getAllowedSubaccounts" />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 m-b-20">
            <InputText
              :label="$t('name')"
              v-model="form.name" />
          </div>
          <div class="col-xs-12 m-b-20">
            <InputSelect
              :label="$t('type')"
              v-model="form.type"
              :options="selectOptions(get_automations.entity['types'])"
            />
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import date from '@/mixins/date';
import InfoTextBox from '@/components/global/infoTextBox';

export default {
  name: 'Packages',
  components: { Btn, Popup, InputText, InputSelect, InfoTextBox },
  mixins: [date],
  data() {
    return {
      openPopup: false,
      isEdit: false,
      automationId: '',
      form: {
        name: '',
        type: '',
        is_active: '1',
        status: '2',
        active_from: new Date,
        accessible_for_subaccounts: []
      },
    };
  },
  computed: {
    ...mapGetters([
      'get_automations',
      'get_subaccounts',
      'get_user'
    ]),
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    }
  },
  created() {
     this.$store.dispatch('GET_AUTOMATIONS');
  },
  methods: {
    getIconNameByType(type) {
      const names = {
        '2': 'single',
        '6': 'checkAll',
        '7': 'server',
        '8': 'cloudUpload',
        '9': 'network',
      };

      return names[type.toString()];
    },
    getStatusText(status) {
      const text = {
        '1': 'draft',
        '2': 'active',
        '3': '', //expired
        '4': '' //pending
      };

      return text[status.toString()];
    },
    getStatusClass(status) {
      const statuses = {
        '1': 'draft',
        '2': 'active',
        '3': 'expired',
        '4': 'pending'
      }

      return statuses[status.toString()];
    },
    selectAccessibleSubaccount(val) {
        this.form.accessible_for_subaccounts = val;
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: parseInt(property) });
      }
      return options;
    },
    clearLocalFormData() {
      this.form = {
        name: '',
        type: '',
        is_active: '1',
        status: '2',
        active_from: new Date,
        accessible_for_subaccounts: []
      };
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      //this.packageId = '';
      this.clearLocalFormData();
    },
    submitForm() {
      const action = this.isEdit ? 'EDIT_AUTOMATION' : 'SET_AUTOMATION';
      //Filter subaccounts @todo check this
      this.form.accessible_for_subaccounts = this.form.accessible_for_subaccounts.filter((val) => this.get_user.accessible_subaccounts_array.indexOf(String(val)) > -1);

      this.$store.dispatch(`${action}`, {
        form: this.form,
        id: this.automationId || '',
      }).then(() => {
        this.$store.dispatch('GET_AUTOMATIONS');
        this.openPopup = false;
        this.clearLocalFormData();
      });
    },
    goToAutomation(id) {
      this.$router.push({ path: `/settings/integration/automations/${id}` });
    },
    openNewPopup() {
      this.isEdit = false;
      this.togglePopup();
    },
  },
};
</script>

